'use client'

import { Component, ReactNode } from 'react'

type RenderProps = {
  isMouseOverElement: boolean
}

type Props = {
  children: (props: RenderProps) => ReactNode
  delay: number
}

type State = {
  isMouseOverElement: boolean
}

const DEFAULT_DELAY_MS = 300

class HoverDelay extends Component<Props, State> {
  timeoutId?: NodeJS.Timeout

  static defaultProps = {
    delay: DEFAULT_DELAY_MS,
  }

  state: Readonly<State> = {
    isMouseOverElement: false,
  }

  setIsMouseOverElement = () => {
    this.setState({ isMouseOverElement: true })
  }

  handleMouseEnter = () => {
    const { delay } = this.props
    const { isMouseOverElement } = this.state

    if (isMouseOverElement) return

    this.timeoutId = setTimeout(this.setIsMouseOverElement, delay)
  }

  handleMouseLeave = () => {
    const { isMouseOverElement } = this.state

    if (this.timeoutId) clearTimeout(this.timeoutId)
    if (isMouseOverElement) this.setState({ isMouseOverElement: false })
  }

  render() {
    const { children } = this.props
    const { isMouseOverElement } = this.state

    return (
      <div onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        {children({ isMouseOverElement })}
      </div>
    )
  }
}

export default HoverDelay
